import _ from 'lodash';
import { Errors } from '../constants/errors';
import { EMAIL_REGEX, NAME_REGEX } from '../constants/defaults';

_.mixin({
  /**
   * Validate a given email address with regex.
   * @param {string} email - The email address to be validated
   * @returns {Boolean} - Returns true if valid email or false.
   */
  validateEmail: (email = '') => {
    return EMAIL_REGEX.test(email);
  },

  /**
   * Validate a given email address with regex.
   * @param {string} date of birth to be validated
   * @returns {string or Boolean} -
   * Returns Invalid for invalid DOB
   * Returns  true for age less than 13 years.
   * Returns "Greater" for age greater than 122 years.
   * Returns False for valid age i.e betwenn 13 to 122 years
   */

  calculateAgeNew: (value = '') => {
    const today = new Date(new Date().toDateString().slice(0, 16));
    const ageLowerLimit = today.setFullYear(today.getFullYear() - 13);
    const ageUpperLimit = today.setFullYear(today.getFullYear() + 13 - 122);
    const year = parseInt(value.slice(-4), 10);
    const month = parseInt(value.slice(0, 2), 10);
    const day = parseInt(value.slice(3, 5), 10);
    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    // Adjustment for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }

    const ageInMilliseconds = new Date(value).getTime();
    const ageLowerLimitFlag = ageInMilliseconds <= ageLowerLimit;
    const ageUpperLimitFlag =
      Math.abs(ageInMilliseconds) <= Math.abs(ageUpperLimit);
    if (
      _.isNaN(ageLowerLimit) ||
      _.isNaN(ageUpperLimit) ||
      _.isNaN(ageInMilliseconds) ||
      day < 0 ||
      _.isNaN(day) ||
      (month < 0 && month > 12) ||
      day > monthLength[month - 1] ||
      new Date(value) >
        new Date(new Date().toLocaleDateString('en-US').slice(0, 16)) ||
      (!/^\d{4}$/.test(year) && _.isNaN(year))
    ) {
      return 'Invalid';
    }

    if (ageLowerLimitFlag && ageUpperLimitFlag) {
      return false;
    }

    if (!ageLowerLimitFlag) {
      return true;
    }

    if (!ageUpperLimitFlag) {
      return 'Greater';
    }

    return 'Invalid';
  },

  validateName: (value = '') => {
    return NAME_REGEX.test(value);
  },

  setError: (setError, errorData, name, type) => {
    setError({ ...errorData, ...{ [`${name}Err`]: type ? Errors[type] : '' } });
  },

  handleInputChange: (event, setData, formData) => {
    const { name, value } = event.target;
    setData({ ...formData, [name]: value });
  },

  checkParseString: text => {
    return !_.isEmpty(text) ? JSON.parse(text) : {};
  }
});
